/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ImaginePayMessage {
  id?: string;
  rowId?: number;
  datasetId?: string;
  imaginePayMessageFileId?: string | null;
  messageType?: string | null;
  patientId?: string | null;
  onlinePaymentRequestId?: string | null;
  onlineAccountNumber?: string | null;
  onlineProviderId?: string | null;
  onlineTransactionId?: string | null;
  patientFirstName?: string | null;
  patientLastName?: string | null;
  requestType?: string | null;
  dateOfService?: string | null;
  isCleared?: boolean;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
}
